module.exports = __webpack_public_path__ + "img/avatar-1773.7a6d1231.png";